import React from 'react';
import Input from "components/form/Input";
import { Box, Flex, Stack, useToast } from "@chakra-ui/react";
import GModal from "components/ui/modal/Modal";
import GButton from "components/ui/button/Button";
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { getUsersFilteredData } from '../../services/usersService';

export default function FilterModal({onClose , data }) {
    const { t } = useTranslation();
    const dispatch =useDispatch();

    const [filteredData, setFilteredData] = useState(data);

    // Filter Data
    const [filterCriteria, setFilterCriteria] = useState({
        userName: "",
        email: "",
      });

      const handleFilterUsers = (e) => {
        e.preventDefault();
    
        const filteredResult = data.filter((item) => {
          const { userName , email} = filterCriteria;
    
          let filterUserName = true;
          let filterEmail = true;
    
          if (userName) {
            filterUserName = item?.userFullName?.toLowerCase().includes(userName.toLowerCase());
          }
    
          if (email) {
            filterEmail = item?.email?.toLowerCase().includes(email.toLowerCase());
          }

          return (
            filterUserName &&
            filterEmail 
          );

        });
    
        setFilteredData(filteredResult);
        onClose();
        dispatch(getUsersFilteredData(filteredResult));
      };

  return <>
  
  <GModal
      onClose={onClose}
      modalHeader={t("pages.users.filter_users")}
      modalContent={
        <Box p={4}>
          <form 
            onSubmit={handleFilterUsers}
          >
            <Stack spacing={6}>
              <Input
                label={t("pages.users.user_name")}
                labelStyle={{ textTransform: "capitalize" }}
                placeholder={t("pages.users.user_name")}
                name="userName"
                value={filterCriteria.userName}
                onChange={(e) =>
                  setFilterCriteria({
                    ...filterCriteria,
                    userName: e.target.value,
                  })
                }
              />
              <Input
                label={t("pages.users.email")}
                labelStyle={{ textTransform: "capitalize" }}
                placeholder={t("pages.users.email")}
                name="email"
                value={filterCriteria.email}
                onChange={(e) =>
                  setFilterCriteria({
                    ...filterCriteria,
                    email: e.target.value,
                  })
                }
              />

              <Flex gap={4}>
                <GButton
                  type="submit"
                  title={t("general.save")}
                  bg="primary"
                  color="light"
                  border="1px solid transparent"
                  hover={{
                    color: "primary",
                    borderColor: "primary",
                    bg: "none",
                  }}
                />
                <GButton
                  title={t("general.close")}
                  onClick={onClose}
                  bg="red.600"
                  border="1px solid transparent"
                  color="light"
                  hover={{
                    color: "red.600",
                    borderColor: "red.600",
                    bg: "none",
                  }}
                />
              </Flex>
            </Stack>
          </form>
        </Box>
      }
    />
  
  </>
}
